import React, { useEffect, useState } from 'react'

import { CapitalGainChart } from './CapitalGainChart'

import { calculateCapitalGain } from '../utils'
import { getCapitalGainMetrics } from '../services/hexa.service'

export interface ICapitalGainTimeSeries {
  [year: string]: {
    [month: string]: number
  }
}
export const organiceResponse = (history: any) => {
  const series: {
    [year: string]: {
      [month: string]: number
    }
  } = {}

  const capitalGain: {
    timeSeries: {
      [month: string]: number
    }
    lastYearCapitalGain: number
  } = history?.data?.capitalGain

  const list = Object.keys(capitalGain?.timeSeries)

  for (const serie of list) {
    const year = serie.substring(0, 4)

    const month = serie.substring(5)

    const value = capitalGain?.timeSeries[serie]

    const backup: any = series[year]

    series[year] = {
      ...backup,
      [month]: value
    }
  }

  const seriesCount = Object.keys(series).length
  return {
    timeSeries: series,
    lastYearCapitalGain: capitalGain?.lastYearCapitalGain,
    seriesCount
  }
}

const CapitalGain = ({
  center,
  priceIndex
}: {
  center: { lat: number; lng: number }
  priceIndex: number
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const [capitalGain, setCapitalGain] = useState<number>()

  const [timeSeries, setTimeSeries] = useState<ICapitalGainTimeSeries>()

  const [timeSeriesCount, setTimeSeriesCount] = useState<number>()

  //* Funcitions

  const prepareData = async () => {
    // to continue it is necessary to have a price prediction

    setIsLoading(true)

    const resp = await getCapitalGainMetrics(
      center.lat ?? 19.4183226744924,
      center.lng ?? -99.1625655170643
    )
    if (resp.isSuccess) {
      const { timeSeries, seriesCount } = organiceResponse(resp.data)
      setTimeSeries(timeSeries)
      setTimeSeriesCount(seriesCount)

      const capitalGain = timeSeries
        ? calculateCapitalGain({ timeSeries })
        : undefined
      setCapitalGain(
        capitalGain ? Number(Number(capitalGain).toFixed(2)) : undefined
      )
    }

    setIsLoading(false)
  }

  // observers

  useEffect(() => {
    if (priceIndex) {
      prepareData()
    }
  }, [priceIndex])

  if (priceIndex) {
    return (
      <CapitalGainChart
        isLoading={isLoading}
        capitalGain={capitalGain ?? 0}
        priceIndex={priceIndex ?? 0}
        timeSeries={timeSeries ?? { '2020': { '01': 0 } }}
        periodCount={timeSeriesCount ?? 0}
      />
    )
  }
  return <></>
}

export default CapitalGain
